import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableHeaderDefaultVariants = {
  "contentsType": "textLeft",
  "size": "default",
  "showTopLine": true,
  "showBottomLine": true,
  "showRightLine": true,
  "sortBy": "none",
  "highlighted": false
}
const tableHeaderCompoundVariants = [
  {
    "contentsType": [
      "expand",
      "collapse",
      "spacer",
      "checkbox"
    ],
    "showRightLine": true,
    "css": {
      "rightLine": {
        "display": "none"
      }
    }
  }
]

const tableHeaderSlotNames = [
  [
    "root",
    "table-header__root"
  ],
  [
    "container",
    "table-header__container"
  ],
  [
    "itemWrapper",
    "table-header__itemWrapper"
  ],
  [
    "headerLabel",
    "table-header__headerLabel"
  ],
  [
    "sortButton",
    "table-header__sortButton"
  ],
  [
    "topLine",
    "table-header__topLine"
  ],
  [
    "bottomLine",
    "table-header__bottomLine"
  ],
  [
    "rightLine",
    "table-header__rightLine"
  ],
  [
    "sortingIndicator",
    "table-header__sortingIndicator"
  ],
  [
    "sortingIndex",
    "table-header__sortingIndex"
  ],
  [
    "resizeHandle",
    "table-header__resizeHandle"
  ],
  [
    "headerLabelGroup",
    "table-header__headerLabelGroup"
  ],
  [
    "tooltipIcon",
    "table-header__tooltipIcon"
  ]
]
const tableHeaderSlotFns = /* @__PURE__ */ tableHeaderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableHeaderDefaultVariants, getSlotCompoundVariant(tableHeaderCompoundVariants, slotName))])

const tableHeaderFn = memo((props = {}) => {
  return Object.fromEntries(tableHeaderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableHeaderVariantKeys = [
  "contentsType",
  "showTopLine",
  "showBottomLine",
  "showRightLine",
  "size",
  "sortBy",
  "highlighted"
]
const getVariantProps = (variants) => ({ ...tableHeaderDefaultVariants, ...compact(variants) })

export const tableHeader = /* @__PURE__ */ Object.assign(tableHeaderFn, {
  __recipe__: false,
  __name__: 'tableHeader',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableHeaderVariantKeys,
  variantMap: {
  "contentsType": [
    "expand",
    "collapse",
    "spacer",
    "checkbox",
    "expandGroup",
    "textLeft",
    "textRight"
  ],
  "showTopLine": [
    "true",
    "false"
  ],
  "showBottomLine": [
    "true",
    "false"
  ],
  "showRightLine": [
    "true",
    "false"
  ],
  "size": [
    "default",
    "sm"
  ],
  "sortBy": [
    "none",
    "asc",
    "desc"
  ],
  "highlighted": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tableHeaderVariantKeys)
  },
  getVariantProps
})